var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLoaderMd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 8,
  fill: "currentColor"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  "data-planet": "deimos"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 48.681,
  cy: 9.762,
  r: 1,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  strokeOpacity: 0.2,
  d: "M55.5 28c0 15.188-12.312 27.5-27.5 27.5S.5 43.188.5 28 12.812.5 28 .5 55.5 12.812 55.5 28Z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  "data-planet": "phobos"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.434,
  cy: 18.765,
  r: 2,
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  strokeOpacity: 0.2,
  d: "M41.811 28c0 7.628-6.183 13.811-13.81 13.811-7.629 0-13.812-6.183-13.812-13.81 0-7.629 6.183-13.812 13.811-13.812S41.811 20.372 41.811 28Z"
}))));
export { SvgLoaderMd as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NiIgaGVpZ2h0PSI1NiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDU2IDU2Ij4KICA8Y2lyY2xlIGN4PSIyOCIgY3k9IjI4IiByPSI4IiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICA8ZyBzdHJva2U9ImN1cnJlbnRDb2xvciIgZGF0YS1wbGFuZXQ9ImRlaW1vcyI+CiAgICA8Y2lyY2xlIGN4PSI0OC42ODEiIGN5PSI5Ljc2MiIgcj0iMSIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cGF0aCBzdHJva2Utb3BhY2l0eT0iLjIiIGQ9Ik01NS41IDI4YzAgMTUuMTg3OC0xMi4zMTIyIDI3LjUtMjcuNSAyNy41Uy41IDQzLjE4NzguNSAyOCAxMi44MTIyLjUgMjggLjUgNTUuNSAxMi44MTIyIDU1LjUgMjhaIi8+CiAgPC9nPgogIDxnIHN0cm9rZT0iY3VycmVudENvbG9yIiBkYXRhLXBsYW5ldD0icGhvYm9zIj4KICAgIDxjaXJjbGUgY3g9IjE3LjQzMzYiIGN5PSIxOC43NjUxIiByPSIyIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KICAgIDxwYXRoIHN0cm9rZS1vcGFjaXR5PSIuMiIgZD0iTTQxLjgxMTIgMjguMDAwMWMwIDcuNjI3Ni02LjE4MzUgMTMuODExMS0xMy44MTExIDEzLjgxMTEtNy42Mjc3IDAtMTMuODExMS02LjE4MzUtMTMuODExMS0xMy44MTExIDAtNy42Mjc3IDYuMTgzNC0xMy44MTExIDEzLjgxMTEtMTMuODExMSA3LjYyNzYgMCAxMy44MTExIDYuMTgzNCAxMy44MTExIDEzLjgxMTFaIi8+CiAgPC9nPgo8L3N2Zz4=";